import { AdStatus } from '@/types';
import { QUERY } from '@/constants/common';

const AD = '/elanlar';
const AUTH = '/authentications';
const PROFILE = '/profile';
const HELP = '/help';
const PAGES = '/pages';
const MESSAGES = '/messages';
const WALLET = '/wallet';
const SESSION = '/session';
const SAVED_SEARCHES = '/saved_searches';
const YIGIM = '/yigim';

export const ROUTES = {
  home: '/',
  bookmarks: '/bookmarks',
  collections: '/collections',
  shopBookmarks: '/shop_bookmarks',
  businessLanding: '/business',
  businessMediakit: '/business/mediakit',
  businessCreateShop: '/business/create',
  ad: AD,
  vipAds: `${AD}/vip`,
  newAd: `${AD}/new`,
  login: `${AUTH}/new`,
  messages: MESSAGES,
  messagesPurchase: `${MESSAGES}#purchase`,
  messagesSale: `${MESSAGES}#sale`,
  shops: '/shops',
  shopDetails: (slug: string) => `/shops/${slug}`,
  profile: PROFILE,
  profileAds: (adStatus: AdStatus) => {
    if (adStatus === AdStatus.Published) return `${PROFILE}/published`;
    return `${PROFILE}/${adStatus.toLowerCase()}`;
  },
  settings: `${PROFILE}/settings`,
  editProfile: `${PROFILE}/edit`,
  business: `${PROFILE}/business`,
  buyPlan: `${PROFILE}/business/buy-plan`,
  transactions: `${PROFILE}/transactions`,
  accountTxs: `${PROFILE}/transactions#account`,
  adsTxs: `${PROFILE}/transactions#ads`,
  limits: `${PROFILE}/ad-placement-limits`,
  cards: `${PROFILE}/cards`,
  addBalance: `${PROFILE}/published#${QUERY.replenishment}`,
  payments: `${PROFILE}/payments`,
  help: HELP,
  faq: `${HELP}/popular_questions`,
  top10Questions: `${PAGES}/help`,
  rules: `${PAGES}/rules`,
  terms: `${PAGES}/terms-and-conditions`,
  proposal: `${PAGES}/proposal`,
  paidServices: `${PAGES}/paid-services`,
  privacy: `${PAGES}/privacy`,
  limitsByCategory: `${PAGES}/limits_by_category`,
  about: `${PAGES}/about`,
  packages: `${PAGES}/packages`,
  advertising: `${PAGES}/advertising`,
  advertising_landing: (lang: string) =>
    `https://${lang}ads.digit.az/?utm_source=tapaz&utm_medium=referral&utm_campaign=tapaz_referral&utm_content=burger`,
  walletFinish: `${WALLET}/finish`,
  yigimFinish: `${YIGIM}/finish`,
  session: SESSION,
  savedSearches: SAVED_SEARCHES,
};

export const APP_STORE_URLS = {
  playStore: 'market://details?id=org.tapaz.android',
  appStore: 'itms-apps://itunes.apple.com/app/id1132083305',
  appGallery: 'appmarket://details?id=C103829279',
};

// Routes that are ready for production, others will return 404 in order to show the old FE version
export const READY_ROUTES_FOR_PRODUCTION = [
  ROUTES.home,
  ROUTES.bookmarks,
  ROUTES.businessLanding,
  ROUTES.businessMediakit,
  ROUTES.businessCreateShop,
  ROUTES.ad,
  ROUTES.walletFinish,
  ROUTES.shops,
  ROUTES.collections,
  ROUTES.shopBookmarks,
  ROUTES.savedSearches,
  ROUTES.vipAds,
  ROUTES.profile,
];

export const READY_DESKTOP_ROUTES_FOR_PRODUCTION = [
  ROUTES.home,
  ROUTES.ad,
  ROUTES.walletFinish,
  ROUTES.bookmarks,
  ROUTES.businessLanding,
  ROUTES.businessMediakit,
  ROUTES.businessCreateShop,
  ROUTES.shops,
  ROUTES.collections,
  ROUTES.shopBookmarks,
  ROUTES.savedSearches,
  ROUTES.vipAds,
  ROUTES.profile,
];
